<div class="reviews-container">
  <!-- Header Section -->
  <div class="reviews-header">
    <h3 class="reviews-title">Reviews</h3>
  </div>

  <!-- Reviews List -->
  <div class="reviews-list">
    <div 
      *ngFor="let review of reviews; trackBy: trackById" 
      class="review-card">
      
      <!-- Card Content -->
      <div class="card-content">
        <!-- Header Section -->
        <div class="review-header">
          <!-- Title and Stars Row -->
          <div class="title-section">
            <div class="review-title-wrapper">
              <h4 class="review-title">{{ review.title }}</h4>
            </div>
          </div>
          
          <!-- Star Rating -->
          <div class="star-rating">
            <div 
              *ngFor="let filled of getStarArray(review.rating); trackBy: trackByIndex" 
              class="star-icon"
              [class.filled]="filled">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1.33301L9.8725 5.13634L14 5.66634L11 8.57968L11.745 12.6663L8 10.6663L4.255 12.6663L5 8.57968L2 5.66634L6.1275 5.13634L8 1.33301Z" 
                      stroke="none"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- Info Section -->
        <div class="info-section">
          <!-- Date Info -->
          <div class="info-item">
            <div class="info-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15.83 3.33H4.17c-.92 0-1.67.75-1.67 1.67v11.67c0 .92.75 1.67 1.67 1.67h11.66c.92 0 1.67-.75 1.67-1.67V5c0-.92-.75-1.67-1.67-1.67ZM13.33 1.67v3.33M6.67 1.67v3.33M2.5 8.33h15" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="info-text">{{ review.date }}</span>
          </div>

          <!-- Vehicle Info -->
          <div class="info-item">
            <div class="info-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g>
                  <path d="M3.33 12.5h1.67M15 12.5h1.67M5 15a1.67 1.67 0 1 0 0-3.33A1.67 1.67 0 0 0 5 15ZM15 15a1.67 1.67 0 1 0 0-3.33A1.67 1.67 0 0 0 15 15Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5 11.67h10l-1.07-6.4A1.67 1.67 0 0 0 12.27 4H7.73a1.67 1.67 0 0 0-1.66 1.27L5 11.67Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
            </div>
            <span class="info-text">{{ review.vehicle }}</span>
          </div>
        </div>

        <!-- Review Comment -->
        <div class="review-comment">
          <p>{{ review.comment }}</p>
        </div>
      </div>
    </div>
  </div>
</div> 